/* ar-ao-viewer.js: gemeinsame Bausteine der Add-ons und der Viewer-Dialog (A9, 07.10.2026; Viewer neu als Vollbild-Pop-up in A11, 07.10.2026).
   Wird auf der Produktseite (vor ar-ao.js) und auf der Add-on-Seite geladen, beides defer, nach ar.js.
   - window.ARAO: carousel() (Pfeile, Punkte, Zaehler, Tasten, Wischen), stack(), loops() (Videos starten nur sichtbar), flips() (CSS-Drehung laeuft nur sichtbar), guard(), openViewer(), data()
   - Videos: nur MP4, keines traegt ein Autostart-Attribut. Ein Video mit data-ao-auto startet per IntersectionObserver, sobald mindestens die Haelfte im Bild ist, und pausiert darunter.
     Faellt ein Video aus (error auf dem Video oder der Quelle, play() lehnt ab), ersetzt ein <img> mit dem Poster das Element, nie ein schwarzer Kasten.
     prefers-reduced-motion: nichts startet, das Poster steht. Solange der Viewer offen ist, spielt kein Video der Seite dahinter (Ereignis "ao-viewer" auf document).
   - Viewer: <dialog data-ar-ao-viewer> (snippets/ar-addons-viewer.liquid), Daten aus <script type="application/json" data-ao-data> (snippets/ar-addons-catalog.liquid).
     Ein Klick auf [data-ao-view="<add-on>"] (optional data-ao-at="<Nummer>" oder data-ao-src="<URL>") oeffnet ihn. Vollbild: links die Buehne (Bild oder Video immer ganz, contain),
     Pfeile auf der Buehne, Mini-Leiste, beim Kit fuenf Stil-Chips; rechts die Infos und der Hauptknopf.
     Laden: nur die gezeigte und die naechste Folie bekommen ihre Quelle (Videos preload none, spielen nur, solange sie gezeigt werden).
     Die Mini-Vorschaubilder laden danach einzeln im Hintergrund (THUMB_TRICKLE).
     A14 (08.10.2026): Mini-Leiste nimmt je Eintrag "thumb" (240x), die Buehne "srcset" (800/1200/1600 w); "src" bleibt das Original und der Rueckfall bei Ladefehlern.
     Bilder mit data-ao-fb (Kacheln, Karten, Drehung) fallen bei einem Ladefehler auf das Original zurueck (tryFb).
     Gibt es einen Host (ARAO.host, gesetzt von ar-ao.js auf der Produktseite), heisst der Knopf "Add to my order" bzw. "Added ✓". Sonst "Shop covers" (Link).
     A13 (08.10.2026): Tracklist-Bilder (nur ein Platzhalter-Layout) stehen klein im Viewer (max. 420 px, Handy 300 px, mittig), Unterzeile "Example layout · your tracklist is designed by hand".
     A26 (07.10.2026): Der Viewer ist eine Lightbox (zentriertes Panel, abgedunkelter Grund, Klick daneben schliesst ueber ar.js), siehe ar-ao.css Block A26. Hier nur sizes der Buehne angepasst.
     A30 (07.10.2026): seitenweit nur EIN Video (play-Ereignis in der Erfassungsphase pausiert alle anderen ar-ao-Videos), Spar-Modus (navigator.connection.saveData) wie reduzierte Bewegung (ARAO.SAVE, ARAO.QUIET),
     weiche Raender fuer Chips und Minis am Handy (.is-fade-l / .is-fade-r), aktive Chip per scrollIntoView sichtbar, Video-Mini = kleines Poster (it.thumb).
     ARAO.svgArrow wird von ar-ao.js fuer die Pfeile der Galerie genutzt. */
(function () {
  'use strict';
  if (window.ARAO) return;
  var doc = document;
  var $ = function (s, r) { return (r || doc).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || doc).querySelectorAll(s)); };
  var REDUCED = !!(window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches);
  var THUMB_TRICKLE = true;
  /* A14: Anzeigebreite der Buehne fuer sizes (ab 900 px: Fensterbreite minus Info-Spalte und Rand, sonst volle Breite) */
  /* A26: Lightbox (Panel max. 1180 px breit, Info-Spalte 320 px, Rand und Pfeilrand): ab 900 px hoechstens 690 px, sonst volle Breite */
  var STAGE_SIZES = '(min-width: 900px) min(690px, calc(100vw - 500px)), 100vw';
  /* A30: Spar-Modus (Datensparer des Browsers) wie reduzierte Bewegung: kein Video der Seite startet von selbst, das Poster bleibt, Tippen oeffnet den Viewer.
     Im Viewer selbst (der Nutzer hat ihn bewusst geoeffnet) laufen die Videos wie bisher. */
  var SAVE = !!(navigator.connection && navigator.connection.saveData === true);
  var ARAO = window.ARAO = { REDUCED: REDUCED, SAVE: SAVE, QUIET: REDUCED || SAVE, host: null, viewerOpen: false };

  function openDlg(d) { if (!d) return; if (window.AR && window.AR.openDialog) window.AR.openDialog(d); else if (d.showModal) d.showModal(); }
  ARAO.openDlg = openDlg;

  function stack(els, i) {
    els.forEach(function (el, k) {
      var on = k === i;
      el.classList.toggle('is-on', on);
      el.setAttribute('aria-hidden', on ? 'false' : 'true');
      if ('inert' in el) el.inert = !on;
    });
  }
  ARAO.stack = stack;

  /* ------------------------------------------------------------ Daten */
  var DATA = null;
  function data() {
    if (DATA) return DATA;
    DATA = {};
    var s = $('script[data-ao-data]');
    if (!s) return DATA;
    try { (JSON.parse(s.textContent).addons || []).forEach(function (a) { DATA[a.key] = a; }); } catch (e) { DATA = {}; }
    return DATA;
  }
  ARAO.data = data;

  /* ------------------------------------------------------------ Videos: Ausfall = Poster, Start nur sichtbar */
  function toStill(v) {
    var src = v.getAttribute('poster');
    if (!v.parentNode) return;
    if (!src) { v.parentNode.removeChild(v); return; }
    var img = doc.createElement('img');
    img.className = v.className; img.src = src; img.alt = v.getAttribute('aria-label') || ''; img.decoding = 'async';
    img.setAttribute('data-ao-still', '1');
    v.parentNode.replaceChild(img, v);
  }
  function guard(v) {
    if (v.__aoGuard) return;
    v.__aoGuard = true;
    if (REDUCED) { toStill(v); return; }
    var done = false;
    var fail = function () { if (done) return; done = true; toStill(v); };
    v.addEventListener('error', fail);
    $$('source', v).forEach(function (s) { s.addEventListener('error', fail); });
    v.__aoFail = fail;
  }
  function play(v) {
    if (!v || REDUCED || !v.play) return;
    var inDlg = !!v.closest('dialog');
    if (ARAO.viewerOpen && !inDlg) return;
    if (SAVE && !inDlg) return;
    var p = v.play();
    if (p && p.catch) p.catch(function (err) { if (err && (err.name === 'NotSupportedError') && v.__aoFail) v.__aoFail(); });
  }
  ARAO.play = play;
  /* A30: seitenweit nur EIN Video. Startet eins (Karte, Galerie, Viewer, Add-on-Seite), pausieren alle anderen ar-ao-Videos.
     "play" steigt nicht auf, deshalb Erfassungsphase am document. Schliesst der Viewer, startet ar-ao.js (kitSync) bzw. der Beobachter unten die sichtbare Karte wieder. */
  var VIDEO_SEL = 'video[data-ao-loop], video[data-ao-pvid], video.ar-ao-gal__kvvid';
  doc.addEventListener('play', function (ev) {
    var t = ev.target;
    if (!t || t.tagName !== 'VIDEO' || !t.matches(VIDEO_SEL)) return;
    $$(VIDEO_SEL).forEach(function (o) { if (o !== t && !o.paused) o.pause(); });
  }, true);
  var AUTO = [];
  var io = ('IntersectionObserver' in window) ? new IntersectionObserver(function (en) {
    en.forEach(function (e) {
      var v = e.target;
      if (!v.isConnected) return;
      var vis = e.isIntersecting && (e.intersectionRatio >= 0.5 || e.intersectionRect.height >= window.innerHeight * 0.5);
      v.__aoVis = vis;
      if (vis) play(v); else v.pause();
    });
  }, { threshold: [0, 0.25, 0.5, 0.75, 1] }) : null;
  /* loops(scope): Ausfallschutz fuer alle Videos mit data-ao-loop, Abspielen nur sichtbar fuer die mit data-ao-auto */
  ARAO.loops = function (scope) {
    $$('video[data-ao-loop]', scope || doc).forEach(function (v) {
      guard(v);
      if (!v.isConnected || !v.hasAttribute('data-ao-auto')) return;
      if (io && !v.__aoIo) { v.__aoIo = true; AUTO.push(v); io.observe(v); }
    });
  };
  ARAO.guard = guard;
  /* Tracklist-Drehung: die Animation (nur transform) laeuft nur, solange die Box sichtbar ist */
  var flipIo = ('IntersectionObserver' in window) ? new IntersectionObserver(function (en) {
    en.forEach(function (e) { e.target.classList.toggle('is-on', e.isIntersecting); });
  }, { threshold: 0.15 }) : null;
  ARAO.flips = function (scope) {
    $$('[data-ao-flip]', scope || doc).forEach(function (el) {
      if (el.__aoFlip || REDUCED) return;
      el.__aoFlip = true;
      if (flipIo) flipIo.observe(el); else el.classList.add('is-on');
    });
  };
  /* Bilder mit data-ao-img, die nicht laden (Datei fehlt), werden samt Huelle (data-ao-drop) entfernt; eine leere Beispielreihe faellt ganz weg.
     Gilt fuer die Beispielreihe und den Hintergrund der Kacheln. Zusaetzlich zur ?v=-Probe in den Snippets, falls die URL fuer fehlende Dateien trotzdem ?v= traegt. */
  /* A14: Bilder mit data-ao-fb tragen eine verkleinerte Adresse (srcset); laedt sie nicht, setzt tryFb das Original (data-ao-fb) ein. Einmal pro Bild. */
  function tryFb(im) {
    var fb = im.getAttribute('data-ao-fb');
    if (!fb || im.__aoFb) return false;
    im.__aoFb = true;
    im.removeAttribute('srcset'); im.removeAttribute('sizes');
    im.src = fb;
    return true;
  }
  ARAO.tryFb = tryFb;
  /* Fehler laufen nicht nach oben: Erfassungsphase am document. Bilder mit data-ao-img regelt prune (erst Rueckfall, dann entfernen). */
  doc.addEventListener('error', function (ev) {
    var im = ev.target;
    if (im && im.tagName === 'IMG' && !im.hasAttribute('data-ao-img') && im.hasAttribute('data-ao-fb')) tryFb(im);
  }, true);
  ARAO.prune = function (scope) {
    $$('img[data-ao-fb]:not([data-ao-img])', scope || doc).forEach(function (im) {
      if (im.complete && im.naturalWidth === 0 && im.getAttribute('src')) tryFb(im);
    });
    $$('img[data-ao-img]', scope || doc).forEach(function (im) {
      if (im.__aoP) return;
      im.__aoP = true;
      var drop = function () {
        if (tryFb(im)) return;
        var sel = im.getAttribute('data-ao-drop'), h = (sel && im.closest(sel)) || im, row = h.parentNode;
        if (row) row.removeChild(h);
        if (row && row.classList && row.classList.contains('ar-ao-tile__row') && !row.children.length && row.parentNode) row.parentNode.removeChild(row);
      };
      im.addEventListener('error', drop);
      if (im.complete && im.naturalWidth === 0 && im.getAttribute('src')) drop();
    });
  };
  /* Abspielen steuert der Aufrufer: nur Folie i laeuft, alle anderen pausieren */
  ARAO.playOnly = function (els, i) {
    els.forEach(function (el, k) {
      var v = $('video', el);
      if (!v) return;
      if (k === i) play(v); else v.pause();
    });
  };
  function setViewerOpen(b) {
    ARAO.viewerOpen = b;
    doc.documentElement.classList.toggle('ar-ao-vw-on', b);
    if (b) AUTO.forEach(function (v) { v.pause(); });
    else AUTO.forEach(function (v) { if (v.__aoVis) play(v); });
    try { doc.dispatchEvent(new CustomEvent('ao-viewer', { detail: { open: b } })); } catch (e) {}
  }

  /* ------------------------------------------------------------ Karussell (Viewer, Galerie, Stil-Viewer)
     o.stage: Buehne (Tasten, Wischen), o.count(): Anzahl der Folien, o.apply(i, user): Folie i zeigen.
     Mit o.bar entstehen dort Prev, Punkte, Zaehler, Next. Mit o.bare gibt es keine Leiste: o.prevBtn und o.nextBtn sind vorhandene Knoepfe, o.onCount(text) bekommt "2 / 7". */
  function svgArrow(dir) {
    var s = doc.createElementNS('http://www.w3.org/2000/svg', 'svg');
    s.setAttribute('viewBox', '0 0 24 24'); s.setAttribute('aria-hidden', 'true');
    var p = doc.createElementNS('http://www.w3.org/2000/svg', 'path');
    p.setAttribute('d', dir === 'prev' ? 'M19 12H6M11 6l-6 6 6 6' : 'M5 12h13M13 6l6 6-6 6');
    s.appendChild(p);
    return s;
  }
  ARAO.svgArrow = svgArrow;
  ARAO.carousel = function (o) {
    var idx = 0, prev, next, dotsEl, countEl, dots = [];
    function n() { return o.count(); }
    function mkBtn(dir) {
      var b = doc.createElement('button');
      b.type = 'button'; b.className = 'ar-ao-car__btn ar-ao-car__btn--' + dir;
      b.setAttribute('aria-label', dir === 'prev' ? 'Previous slide' : 'Next slide');
      var i = doc.createElement('i'); i.appendChild(svgArrow(dir)); b.appendChild(i);
      var t = doc.createElement('span'); t.textContent = dir === 'prev' ? 'Prev' : 'Next'; b.appendChild(t);
      b.addEventListener('click', function () { go(dir === 'prev' ? -1 : 1); });
      return b;
    }
    function build() {
      dots = [];
      if (o.bare) { if (o.prevBtn) o.prevBtn.hidden = o.nextBtn.hidden = n() < 2; return; }
      o.bar.textContent = '';
      prev = mkBtn('prev');
      dotsEl = doc.createElement('span'); dotsEl.className = 'ar-ao-car__dots';
      for (var k = 0; k < n(); k++) {
        (function (k) {
          var d = doc.createElement('button');
          d.type = 'button'; d.className = 'ar-ao-car__dot';
          d.setAttribute('aria-label', 'Show slide ' + (k + 1) + ' of ' + n());
          d.addEventListener('click', function () { show(k, true); });
          dotsEl.appendChild(d); dots.push(d);
        })(k);
      }
      countEl = doc.createElement('span'); countEl.className = 'ar-ao-car__count'; countEl.setAttribute('aria-hidden', 'true');
      next = mkBtn('next');
      o.bar.appendChild(prev); o.bar.appendChild(dotsEl); o.bar.appendChild(countEl); o.bar.appendChild(next);
      o.bar.hidden = n() < 2;
    }
    function show(i, user) {
      var c = n();
      if (!c) return;
      idx = ((i % c) + c) % c;
      dots.forEach(function (d, k) { d.classList.toggle('is-on', k === idx); if (k === idx) d.setAttribute('aria-current', 'true'); else d.removeAttribute('aria-current'); });
      if (countEl) countEl.textContent = (idx + 1) + ' / ' + c;
      if (o.onCount) o.onCount((idx + 1) + ' / ' + c);
      o.apply(idx, !!user);
    }
    function go(d) { show(idx + d, true); }
    function refresh(keep, at) { build(); show(at != null ? at : (keep ? Math.min(idx, Math.max(0, n() - 1)) : 0), false); }
    if (o.bare && o.prevBtn) {
      o.prevBtn.addEventListener('click', function () { go(-1); });
      o.nextBtn.addEventListener('click', function () { go(1); });
    }
    o.stage.addEventListener('keydown', function (ev) {
      if (ev.key === 'ArrowLeft') { ev.preventDefault(); go(-1); } else if (ev.key === 'ArrowRight') { ev.preventDefault(); go(1); }
    });
    var sx = null, sy = null;
    o.stage.addEventListener('pointerdown', function (ev) { if (ev.pointerType === 'mouse' && ev.button !== 0) return; sx = ev.clientX; sy = ev.clientY; });
    o.stage.addEventListener('pointercancel', function () { sx = null; });
    o.stage.addEventListener('pointerup', function (ev) {
      if (sx === null) return;
      var dx = ev.clientX - sx, dy = ev.clientY - sy; sx = null;
      if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy) * 1.4) go(dx < 0 ? 1 : -1);
    });
    return { show: show, go: go, refresh: refresh, index: function () { return idx; } };
  };

  /* ------------------------------------------------------------ Viewer */
  var dlg = $('dialog[data-ar-ao-viewer]');
  if (dlg) doc.body.appendChild(dlg);

  function init() {
    ARAO.loops(doc);
    ARAO.flips(doc);
    ARAO.prune(doc);
  }
  if (!dlg) {
    ARAO.openViewer = function () {};
    init();
    return;
  }

  var stage = $('[data-ao-vw-stage]', dlg), capEl = $('[data-ao-vw-cap]', dlg);
  var strip = $('[data-ao-vw-strip]', dlg), stripWrap = $('[data-ao-vw-stripwrap]', dlg), chipsEl = $('[data-ao-vw-chips]', dlg);
  var prevB = $('[data-ao-vw-prev]', dlg), nextB = $('[data-ao-vw-next]', dlg);
  var kEl = $('[data-ao-vw-k]', dlg), tEl = $('[data-ao-vw-title]', dlg), pEl = $('[data-ao-vw-price]', dlg), txEl = $('[data-ao-vw-text]', dlg);
  var fmtEl = $('[data-ao-vw-fmt]', dlg), delEl = $('[data-ao-vw-del]', dlg), addB = $('[data-ao-vw-add]', dlg), shopA = $('[data-ao-vw-shop]', dlg);
  var cur = null, items = [], figs = [], ths = [], opener = null, car = null, styleKey = '', token = 0, countText = '';

  /* A30 (Handy): Stil-Chips und Minis sind je eine waagerecht scrollbare Zeile. Ein weicher Rand (.is-fade-l / .is-fade-r, CSS in ar-ao.css, mask-image) zeigt, dass links oder rechts mehr kommt.
     Die aktive Chip wird per scrollIntoView sichtbar gehalten. Am Rechner (kein Ueberlauf) passiert nichts. */
  function fadeSync(el) {
    if (!el) return;
    var max = el.scrollWidth - el.clientWidth;
    el.classList.toggle('is-fade-l', max > 2 && el.scrollLeft > 2);
    el.classList.toggle('is-fade-r', max > 2 && el.scrollLeft < max - 2);
  }
  function edges() { requestAnimationFrame(function () { fadeSync(chipsEl); fadeSync(strip); }); }
  [chipsEl, strip].forEach(function (el) { if (el) el.addEventListener('scroll', function () { fadeSync(el); }, { passive: true }); });
  window.addEventListener('resize', function () { if (dlg.open) edges(); }, { passive: true });
  function keepChip() {
    var c = $('[data-ao-vw-style][aria-checked="true"]', chipsEl);
    if (c && c.scrollIntoView && chipsEl.scrollWidth > chipsEl.clientWidth + 2) { try { c.scrollIntoView({ inline: 'nearest', block: 'nearest' }); } catch (e) {} }
    edges();
  }

  /* A13: Die Tracklist-Bilder sind nur ein Platzhalter (Beispiel-Layout), deshalb klein gezeigt und anders beschriftet */
  function isTracks() { return !!(cur && cur.key === 'tracks'); }
  function capFor(it) { return isTracks() ? 'Example layout · your tracklist is designed by hand' : 'Example on a sample cover' + (it && it.fmt ? ' · ' + it.fmt : ''); }
  function setCap(i) {
    if (!capEl) return;
    capEl.textContent = '';
    var a = doc.createElement('span'); a.textContent = capFor(items[i]); capEl.appendChild(a);
    if (countText) { var b = doc.createElement('span'); b.className = 'ar-ao-vw__count'; b.textContent = countText; capEl.appendChild(b); }
  }
  function syncHost() {
    if (!cur || !ARAO.host || !ARAO.host.has(cur.key)) return;
    var on = !!ARAO.host.isOn(cur.key);
    addB.textContent = on ? 'Added ✓' : 'Add to my order';
    addB.setAttribute('aria-pressed', on ? 'true' : 'false');
    addB.classList.toggle('is-on', on);
  }
  ARAO.syncViewer = syncHost;

  /* Eine Folie bekommt ihr Bild oder Video erst, wenn sie gezeigt wird oder die naechste ist */
  function fill(i) {
    var f = figs[i], it = items[i];
    if (!f || !it || f.__filled) return;
    f.__filled = true;
    if (it.t === 'v') {
      var v = doc.createElement('video');
      v.className = 'ar-ao-vw__img'; v.muted = true; v.loop = true; v.setAttribute('muted', ''); v.setAttribute('loop', ''); v.setAttribute('playsinline', ''); v.playsInline = true;
      v.preload = 'none'; v.setAttribute('disablepictureinpicture', ''); v.setAttribute('data-ao-loop', '');
      v.poster = it.poster; v.setAttribute('aria-label', (cur ? cur.title : 'Preview') + ' video, 10 s');
      var s = doc.createElement('source'); s.src = it.src; s.type = 'video/mp4'; v.appendChild(s);
      f.appendChild(v);
      ARAO.guard(v);
    } else {
      var im = doc.createElement('img');
      im.className = 'ar-ao-vw__img' + (isTracks() ? ' ar-ao-vw__img--small' : ''); im.draggable = false; im.decoding = 'async';
      im.alt = isTracks() ? 'Tracklist, example layout' + (it.fmt ? ', ' + it.fmt : '') : (cur ? cur.title : 'Preview') + ', example on a sample cover' + (it.fmt ? ', ' + it.fmt : '');
      /* A14: srcset (800/1200/1600 w) statt des Originals; faellt es aus, laedt einmal das Original, erst danach faellt das Bild aus der Reihe */
      im.addEventListener('error', function () {
        if (it.srcset && !im.__aoFb) { im.__aoFb = true; im.removeAttribute('srcset'); im.removeAttribute('sizes'); im.src = it.src; return; }
        dropItem(it);
      });
      if (it.srcset) { im.sizes = isTracks() ? '420px' : STAGE_SIZES; im.srcset = it.srcset; }
      im.src = it.src;
      f.appendChild(im);
    }
    var th = ths[i];
    if (th && !th.__filled) loadThumb(i);
  }
  function loadThumb(i) {
    var th = ths[i], it = items[i];
    if (!th || !it || th.__filled) return;
    th.__filled = true;
    var im = th.querySelector('img');
    if (!im) return;
    /* A30: Video-Mini = kleines Poster (it.thumb, kitvid-<stil>-sm.jpg), bei Ladefehler das grosse Poster */
    if (it.t === 'v') {
      if (it.thumb && it.thumb !== it.poster) im.addEventListener('error', function () { if (!im.__aoFb) { im.__aoFb = true; im.src = it.poster; } });
      im.src = it.thumb || it.poster;
      return;
    }
    /* A14: kleine Fassung (it.thumb, 240x) statt des Originals; bei Ladefehler einmal das Original */
    if (it.thumb && it.thumb !== it.src) im.addEventListener('error', function () { if (!im.__aoFb) { im.__aoFb = true; im.src = it.src; } });
    im.src = it.thumb || it.src;
  }
  /* Die Mini-Vorschaubilder laden nacheinander im Hintergrund, nachdem die gezeigten Folien da sind */
  function trickle() {
    if (!THUMB_TRICKLE) return;
    var my = token, k = 0;
    ths.forEach(function (th, i) {
      if (th.__filled) return;
      k++;
      setTimeout(function () { if (my === token && dlg.open) loadThumb(i); }, 500 + k * 140);
    });
  }
  /* Ein Bild, das nicht laedt (Datei fehlt), faellt aus der Reihe */
  function dropItem(it) {
    var i = items.indexOf(it);
    if (i < 0) return;
    var keep = car ? car.index() : 0;
    items.splice(i, 1);
    if (!items.length) { closeNow(); return; }
    build(items, Math.min(i < keep ? keep - 1 : keep, items.length - 1));
  }
  function closeNow() { if (window.AR && window.AR.closeDialog) window.AR.closeDialog(dlg); else if (dlg.close) dlg.close(); }

  car = ARAO.carousel({
    stage: stage, bare: true, prevBtn: prevB, nextBtn: nextB,
    count: function () { return items.length; },
    onCount: function (t) { countText = t; },
    apply: function (i) {
      stack(figs, i);
      fill(i); fill((i + 1) % Math.max(1, items.length));
      setCap(i);
      ths.forEach(function (b, k) { b.classList.toggle('is-on', k === i); if (k === i) b.setAttribute('aria-current', 'true'); else b.removeAttribute('aria-current'); });
      var cb = ths[i];
      if (cb && strip.scrollWidth > strip.clientWidth) strip.scrollLeft = cb.offsetLeft - (strip.clientWidth - cb.offsetWidth) / 2;
      ARAO.playOnly(figs, dlg.open ? i : -1);
    }
  });

  /* Folien und Mini-Leiste aus einer Liste bauen */
  function build(list, at) {
    items = list;
    token++;
    stage.textContent = ''; strip.textContent = ''; ths = []; figs = [];
    items.forEach(function (it, k) {
      var f = doc.createElement('figure');
      f.className = 'ar-ao-vw__slide'; f.setAttribute('data-ao-slide', '');
      stage.appendChild(f); figs.push(f);
      var b = doc.createElement('button');
      b.type = 'button'; b.className = 'ar-ao-vw__th';
      b.setAttribute('aria-label', 'Show ' + (it.t === 'v' ? 'the video' : 'picture ' + (k + 1)) + (it.fmt ? ', ' + it.fmt : ''));
      var im = doc.createElement('img'); im.alt = ''; im.decoding = 'async';
      b.appendChild(im);
      if (it.t === 'v') { var l = doc.createElement('span'); l.className = 'ar-ao-vw__th-l'; l.textContent = 'Video'; b.appendChild(l); }
      b.addEventListener('click', function () { car.show(k, true); });
      strip.appendChild(b); ths.push(b);
    });
    stripWrap.hidden = items.length < 2;
    car.refresh(false, Math.max(0, Math.min(at || 0, items.length - 1)));
    trickle();
    edges();
  }

  /* Stil-Chips (nur Kit) */
  function stylesOf(a) { return (a.styles || []).filter(function (s) { return s.items && s.items.length; }); }
  function chipState() {
    $$('[data-ao-vw-style]', chipsEl).forEach(function (c) {
      var on = c.getAttribute('data-ao-vw-style') === styleKey;
      c.setAttribute('aria-checked', on ? 'true' : 'false'); c.tabIndex = on ? 0 : -1;
    });
    keepChip();
  }
  function pickStyle(key, user) {
    if (!cur || key === styleKey) return;
    var st = stylesOf(cur).filter(function (s) { return s.key === key; })[0];
    if (!st) return;
    styleKey = key;
    chipState();
    build(st.items.slice(), car.index());
    if (user && ARAO.host && ARAO.host.setStyle) ARAO.host.setStyle(key);
  }
  function mkChips(a) {
    chipsEl.textContent = '';
    var sts = stylesOf(a);
    chipsEl.hidden = sts.length < 2;
    if (sts.length < 2) return;
    sts.forEach(function (s) {
      var c = doc.createElement('button');
      c.type = 'button'; c.className = 'ar-ao-vw__chip'; c.setAttribute('role', 'radio'); c.setAttribute('data-ao-vw-style', s.key);
      c.textContent = s.name;
      c.addEventListener('click', function () { pickStyle(s.key, true); });
      chipsEl.appendChild(c);
    });
    chipState();
  }

  /* at: Nummer in der Liste oder (Beispielreihe der Kacheln) die URL des Bildes */
  ARAO.openViewer = function (key, at, from) {
    var a = data()[key];
    if (!a) return;
    var sts = stylesOf(a), list;
    cur = a; opener = from || doc.activeElement;
    styleKey = '';
    if (sts.length) {
      var want = (ARAO.host && ARAO.host.style && ARAO.host.style()) || a.style || 'xerox';
      var st = sts.filter(function (s) { return s.key === want; })[0] || sts[0];
      styleKey = st.key; list = st.items.slice();
    } else list = (a.items || []).slice();
    if (!list.length) return;
    if (typeof at === 'string') {
      var ix = -1;
      list.forEach(function (it, i) { if (ix < 0 && it.src === at) ix = i; });
      at = ix < 0 ? 0 : ix;
    }
    kEl.textContent = a.kicker || ''; kEl.hidden = !a.kicker;
    tEl.textContent = a.title; pEl.textContent = a.price || ''; txEl.textContent = a.text || '';
    fmtEl.textContent = '';
    (a.formats || []).forEach(function (f) { var li = doc.createElement('li'); li.textContent = f; fmtEl.appendChild(li); });
    delEl.textContent = a.delivery || ''; delEl.hidden = !a.delivery;
    var hosted = !!(ARAO.host && ARAO.host.has(a.key));
    addB.hidden = !hosted; shopA.hidden = hosted;
    if (hosted) syncHost();
    stage.setAttribute('aria-label', a.title + ' preview');
    mkChips(a);
    var scroller = $('.ar-ao-vw__scroll', dlg), gridEl = $('.ar-ao-vw__grid', dlg);
    if (scroller) scroller.scrollTop = 0;
    if (gridEl) gridEl.scrollTop = 0; /* A30: am Handy scrollt das ganze Raster */
    setViewerOpen(true);
    openDlg(dlg);
    build(list, at);
    keepChip(); /* A30: die Chips wurden vor dem Oeffnen gebaut, jetzt (sichtbar) die aktive Chip in die Zeile holen */
  };

  dlg.addEventListener('close', function () {
    token++;
    ARAO.playOnly(figs, -1);
    stage.textContent = ''; figs = [];
    setViewerOpen(false);
    if (opener && opener.isConnected && opener.focus) { try { opener.focus({ preventScroll: true }); } catch (e) { opener.focus(); } }
  });
  dlg.addEventListener('keydown', function (ev) {
    if (ev.defaultPrevented) return;
    /* Fokus-Falle: Tab und Shift+Tab drehen im Dialog um (der Rest der Seite ist inert, der Fokus soll nicht in die Browserleiste wandern) */
    if (ev.key === 'Tab') {
      var f = $$('button:not([disabled]), a[href], [tabindex]:not([tabindex="-1"])', dlg).filter(function (e) { return !e.hidden && !e.closest('[hidden]') && !e.closest('[inert]') && e.offsetParent !== null; });
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1], a = doc.activeElement;
      if (ev.shiftKey && (a === first || !dlg.contains(a))) { ev.preventDefault(); last.focus(); }
      else if (!ev.shiftKey && (a === last || !dlg.contains(a))) { ev.preventDefault(); first.focus(); }
      return;
    }
    if (ev.target && /^(INPUT|TEXTAREA|SELECT)$/.test(ev.target.tagName)) return;
    /* Stil-Chips: Pfeile wechseln den Stil statt der Folie */
    var chip = ev.target && ev.target.closest && ev.target.closest('[data-ao-vw-style]');
    if (chip && /^Arrow(Left|Right|Up|Down)$/.test(ev.key)) {
      var cs = $$('[data-ao-vw-style]', chipsEl), i = cs.indexOf(chip);
      ev.preventDefault();
      var nx = cs[(i + (/Left|Up/.test(ev.key) ? -1 : 1) + cs.length) % cs.length];
      nx.focus(); pickStyle(nx.getAttribute('data-ao-vw-style'), true);
      return;
    }
    if (ev.key === 'ArrowLeft') { ev.preventDefault(); car.go(-1); } else if (ev.key === 'ArrowRight') { ev.preventDefault(); car.go(1); }
  });
  addB.addEventListener('click', function () {
    if (cur && ARAO.host && ARAO.host.toggle) { ARAO.host.toggle(cur.key); syncHost(); }
  });

  doc.addEventListener('click', function (ev) {
    var b = ev.target.closest && ev.target.closest('[data-ao-view]');
    if (!b || b.disabled) return;
    ev.preventDefault();
    ARAO.openViewer(b.getAttribute('data-ao-view'), b.getAttribute('data-ao-src') || parseInt(b.getAttribute('data-ao-at'), 10) || 0, b);
  });

  /* Knoepfe fuer Add-ons ohne jedes Bild (Dateien fehlen) sind nutzlos: aus */
  $$('[data-ao-view]').forEach(function (b) {
    var a = data()[b.getAttribute('data-ao-view')];
    var has = !!a && ((a.items && a.items.length) || stylesOf(a).length);
    if (has) return;
    if (b.classList.contains('ar-ao-tile__pv')) b.hidden = true;
    else { b.disabled = true; b.tabIndex = -1; }
  });

  init();
})();
